// extracted by mini-css-extract-plugin
module.exports = {"header":"survey-intro_header__o9Qmi","welcome":"survey-intro_welcome__IWZTS","participant":"survey-intro_participant__3Gpvc","info":"survey-intro_info__2UR1I"};